import React from "react";

const COLORS = [
  ["#7C6FE0", "#EEEDFE"],
  ["#185FA5", "#E6F1FB"],
  ["#3B6D11", "#EAF3DE"],
  ["#854F0B", "#FAEEDA"],
  ["#A32D2D", "#FCEBEB"],
  ["#5C6BC0", "#E8EAF6"],
  ["#00838F", "#E0F7FA"],
  ["#6D4C41", "#EFEBE9"],
];

function colorFor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return COLORS[Math.abs(hash) % COLORS.length];
}

export default function Avatar({ prenom = "", nom = "", size = 32, fontSize = 12 }) {
  const initiales = ((prenom[0] || "") + (nom[0] || "")).toUpperCase();
  const [fg, bg] = colorFor(prenom + nom);
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: bg, color: fg,
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      fontSize, fontWeight: 700, flexShrink: 0,
      letterSpacing: "0.5px", userSelect: "none"
    }}>
      {initiales || "?"}
    </div>
  );
}
